var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 11V11C21 9.60218 21 8.90326 20.7716 8.35195C20.4672 7.61687 19.8831 7.03284 19.1481 6.72836C18.5967 6.5 17.8978 6.5 16.5 6.5H12C9.17157 6.5 7.75736 6.5 6.87868 7.37868C6 8.25736 6 9.67157 6 12.5V17C6 18.3978 6 19.0967 6.22836 19.6481C6.53284 20.3831 7.11687 20.9672 7.85195 21.2716C8.40326 21.5 9.10218 21.5 10.5 21.5V21.5",
    stroke: "#0D0F18",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15.5,
    width: 15,
    height: 15,
    rx: 3,
    stroke: "#0D0F18",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2c343570dc1ad54f3d7d0f75df1a5b2c.svg";
export { ForwardRef as ReactComponent };